export enum AddonType {
  None = 'None',
  TopOff = 'TopOff',
}
